"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.websiteTypographyMixin = void 0;
const styled_components_1 = require("styled-components");
const websiteTheme_1 = require("./websiteTheme");
const websiteTypographyMixin = (kind, size, type) => {
    const kindBranch = websiteTheme_1.websiteTheme[kind];
    if (!(size in kindBranch)) {
        throw new Error(`Website typography: ${size} size is not supported for website/${kind} typography`);
    }
    const sizeBranch = kindBranch[size];
    if (!(type in sizeBranch)) {
        throw new Error(`Website typography: ${type} type is not supported for website/${kind}/${size} typography`);
    }
    const typeBranch = sizeBranch[type];
    return (0, styled_components_1.css) `
    font-family: ${kindBranch.fontFamily};
    font-size: ${sizeBranch.fontSize};
    line-height: ${sizeBranch.lineHeight};
    color: ${typeBranch.color};
    font-weight: ${typeBranch.fontWeight};
  `;
};
exports.websiteTypographyMixin = websiteTypographyMixin;
//# sourceMappingURL=websiteTypographyMixin.js.map